import React from "react";
import FeatureDocumentation from "../../components/layouts/docsection";
import AddEmployee from "../../images/addEmployee.png";
import EditEmployee from "../../images/editEmployee.png";

const ManageEmployees = () => {
  const ManageEmployeesDocs = {
    title: "Manage Employees",
    description: "Learn how to efficiently manage employee information, including adding, updating, and viewing their details.",
    sections: [
      {
        title: "Overview",
        content:
          "The Manage Employees feature allows you to add, update, and view employee details in a streamlined manner.",
      },
      {
        title: "Manage Employees",
        content:
          "Adding and updating employee information is facilitated through various modals that need to be completed.",
        subsections: [
          {
            title: "Add Employee",
            content: "Fill in the necessary details to add a new employee.",
            image: AddEmployee,
            imageAlt: "Add Employee Modal",
            imageCaption: "Figure 1: Comprehensive view of the add employee modal",
            steps: [
              "Department: Select the department to which the employee belongs.",
              "Employee: Enter the employee's full name and relevant details.",
              "Next of Kin: Provide information about the employee's next of kin for emergency contact.",
              "Employee Address: Fill in the complete address of the employee.",
              "Preview: Review the entered details before saving.",
            ],
          },
          {
            title: "Update Employee",
            content:
              "Update existing employee details by editing the respective modals.",
            image: EditEmployee,
            imageAlt: "Edit Employee Modal",
            imageCaption: "Figure 1: Comprehensive view of the edit employee modal",
            steps: [
              "Department: Update the department if necessary.",
              "Employee: Modify the employee's name and relevant information.",
              "Next of Kin: Update the next of kin details as needed.",
              "Employee Address: Change the employee's address if applicable.",
              "Preview: Review the updated details before saving changes.",
            ],
          },
        ],
      },
    ],
  };
  
  return <FeatureDocumentation {...ManageEmployeesDocs} />;
};

export default ManageEmployees;
